import * as router from "./router";

export function sensor_router_match(pathname) {
    if (!pathname) return '';
    let _router_match = router.router_matcbh(pathname);

    // business logic
    if (_router_match == "hot") _router_match = "search"
    if (_router_match == "product") _router_match = "pdp"

    // add suffix
    if (_router_match == "search" && _router_match == "brand" && _router_match == "category") _router_match += "-search";
    return _router_match;
}

export function sensor_router_type(pathname) {
    if (!pathname) return '';
    let _router_match = router.router_matcbh_v2(pathname) || 'other';
    if (_router_match == 'other') _router_match = router.router_matcbh_v3(pathname) || 'other';
    if (_router_match == "List") _router_match = "List-page"
    if (_router_match == "Campaign") _router_match = "Campaign-page"
    if (_router_match == "Search" ) _router_match = "Search-page";
    if ( _router_match == "product" ) _router_match = "Product-detail-page"
    if ( _router_match == "Function" ) _router_match = "Function-page"

    return _router_match;
}


// WEBPACK FOOTER //
// ./common/Mapping/sensorMap.js